// Tipos compartidos entre el calendario propio (V2) y el contenedor único de
// reservación. La selección vive fuera de los componentes para que "Editar
// selección" regrese al calendario sin perder nada.

export interface TourV2Selection {
  date: string | null;
  startTimeId: number | null;
  startTime: string | null;
  /** pricingCategoryId -> cantidad */
  qty: Record<string, number>;
}

export interface TourV2PriceRow {
  id: string;
  title: string;
  minAge: number | null;
  maxAge: number | null;
  price: number;
  currency: string;
  /** Precio por reserva (grupo/vehículo/embarcación): no se multiplica por persona. */
  perBooking?: boolean;
  /** Máximo de personas que cubre el precio por grupo. */
  groupMax?: number | null;
}

export interface TourV2Quote {
  selection: TourV2Selection;
  rows: TourV2PriceRow[];
  currency: string;
  total: number;
  pax: number;
  complete: boolean;
}

export const emptySelection: TourV2Selection = {
  date: null,
  startTimeId: null,
  startTime: null,
  qty: {},
};

/** Importe de una fila: por grupo = precio fijo si hay personas; si no, precio × cantidad. */
export function rowAmount(row: TourV2PriceRow, qty: number): number {
  if (row.perBooking) return qty > 0 ? row.price : 0;
  return row.price * qty;
}

export function ageLabel(row: TourV2PriceRow): string | null {
  if (row.perBooking) return null;
  if (row.minAge == null && row.maxAge == null) return null;
  if (row.minAge != null && row.maxAge != null) return `${row.minAge}–${row.maxAge}`;
  if (row.minAge != null) return `${row.minAge}+`;
  return `0–${row.maxAge}`;
}
